import React, { useState, useEffect } from 'react';
import { ConfigProvider, Calendar, theme, Card, message, Spin, Tag, DatePicker, Button, Tooltip } from 'antd';
import '../../styles/Dashboard.css';
import { API_URL, API_username, API_password } from '../../utils/api';
import { CloseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import locale from 'antd/locale/ru_RU';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
dayjs.locale('ru');

const PersonnelDataContent = ({ shortInfo }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [showLeaveBalanceModal, setShowLeaveBalanceModal] = useState(false);
    const [leaveBalances, setLeaveBalances] = useState([]);
    const [showAbsenceListModal, setShowAbsenceListModal] = useState(false);
    const [absenceList, setAbsenceList] = useState([]);
    const [showTimesheetModal, setShowTimesheetModal] = useState(false);
    const [timesheetData, setTimesheetData] = useState([]);
    const [isTimesheetDataExist, setIsTimesheetDataExist] = useState(0);
    const [timesheetPeriod, setTimesheetPeriod] = useState('');
    const [monthName, setMonthName] = useState('');

    useEffect(() => {
		const fetchData = async () => {
            await Promise.all([getLeaveBalance(), getAbsenceList()]);
            setLoading(false);
        };
        fetchData();	
	}, []);

    const onPanelChange = (value, mode) => {
        // Handle calendar panel change
    };

    const { token } = theme.useToken();
    const wrapperStyle = {
        width: 350,
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadiusLG,
        marginRight: '16px'
    };

    const formatDate = (date) => {
      const rawDate = date.split('T')[0];
      const dateParts = rawDate.split('-');
      return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
    }

    const getLeaveBalance = () => {
        let apiUrl = `${API_URL}/lk?method=GetLeaveBalance&inbody=0`;
        let sessionId = localStorage.getItem("SessionId");
        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
                'sessionid': sessionId
            }
        })
        .then(response => {
            if (response.status === 200) {
                return response.json();
            } else if (response.status === 202) {
                message.error('Сервер на данный момент перегружен!');
                return "error";
            } else if (response.status === 404) {
                message.error('Сессия не найдена, попробуйте еще раз!');
                navigate('/logout');
                return "error";
            } else {
                message.error('Произошла ошибка при отправке запроса!');
                return "error";
            }
        })
        .then(data => {
            if (data.status === "Сотрудник найден в организации.") {
                const index = data.VacationBalances.length - 1;
                let vacationDetails = data.VacationBalances[index].VacationDetails;
                // Раскомментировать если надо суммировать остатки по Трансферу
                // const priorityOne = vacationDetails.find(item => item.Priority === 1);
                // if (priorityOne) {
                //     const transferItems = vacationDetails.filter(item => item.Type && item.Type.includes("Трансфер"));
                //     transferItems.forEach(transferItem => {
                //         priorityOne.Balance += transferItem.Balance;
                //     });
                // }
                vacationDetails = vacationDetails.filter(item => !(item.Type && item.Type.includes("Трансфер")));
                const sortedData = vacationDetails.sort((a, b) => new Date(a.Priority) - new Date(b.Priority));
                setLeaveBalances(sortedData);     
                setLoading(false);
            }
        })
        .catch(error => {
            message.error('Ошибка: ' + error.message);
        });
    };

    const totalBalance = leaveBalances.reduce((acc, balance) => acc + balance.Balance, 0);
    
    const absenceColors = {
        'Болезнь': 'red',
        'Командировка': 'green',
        'Внутренняя командировка': 'green',
    };

    const getAbsenceColor = (absenceType) => {
        return absenceColors[absenceType] || 'blue';
    };

    const getAbsenceList = () => {
        let apiUrl = `${API_URL}/lk?method=GetAbsenceList&inbody=0`;
        let sessionId = localStorage.getItem("SessionId");
        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
                'sessionid': sessionId
            }
        })
        .then(response => {
            if (response.status === 200) {
                return response.json();
            } else if (response.status === 202) {
                message.error('Сервер на данный момент перегружен!');
                return "error";
            } else if (response.status === 404) {
                message.error('Сессия не найдена, попробуйте еще раз!');
                navigate('/logout');
                return "error";
            } else {
                message.error('Произошла ошибка при отправке запроса!');
                return "error";
            }
        })
        .then(data => {
            if (data.status === "Сотрудник найден у физического лица.") {
                const tempAbsenceList = data.AbsenceDocuments;
                tempAbsenceList.sort((a, b) => {
                    return new Date(a.StartDate) - new Date(b.StartDate);
                });
                setAbsenceList(tempAbsenceList);      
                setLoading(false);
            }
        })
        .catch(error => {
            message.error('Ошибка: ' + error.message);
        });
    };

    const getTimesheetByPeriod = () => {
        if(timesheetPeriod === '') message.info('Выберите месяц табелирования!');
        else {
            let apiUrl = `${API_URL}/lk?method=GetTimesheetByPeriod&inbody=1`;
            let sessionId = localStorage.getItem("SessionId");
            fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
                    'sessionid': sessionId
                },
                body: JSON.stringify({"RequestDate": timesheetPeriod})
            })
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                } else if (response.status === 202) {
                    message.error('Сервер на данный момент перегружен!');
                    return "error";
                } else if (response.status === 404) {
                    message.error('Сессия не найдена, попробуйте еще раз!');
                    navigate('/logout');
                    return "error";
                } else {
                    message.error('Произошла ошибка при отправке запроса!');
                    return "error";
                }
            })
            .then(data => {
                if (data.status === "Сотрудник найден у физического лица." && data.TimesheetData.length !== 0) {
                    setTimesheetData(data.TimesheetData);
                    setIsTimesheetDataExist(1);
                } else if(data.status === "Сотрудник найден у физического лица." && data.TimesheetData.length === 0) {
                    setIsTimesheetDataExist(2);
                }
            })
            .catch(error => {
                message.error('Ошибка: ' + error.message);
            });
        }
    };

    const getTimeTypeColor = (timeType) => {
        return timeTypeColors[timeType] || '#008000';
    };

    const changeTimesheetPeriod = (date, dateString) => {
        const [year, month] = dateString.split('-');
        const dateObj = new Date(year, month - 1);
        setMonthName(dateObj.toLocaleString('ru-RU', { month: 'long' }));
        setTimesheetPeriod(dateString+'-01T00:00:00');
        setIsTimesheetDataExist(0);
    };

    const timeTypeColors = {
        'Больничный': '#999',
        'Выходные дни': '#c21227',
        'Отпуск': '#00b4d8',
        'Дополнительный отпуск': '#00b4d8',
        'Прогул': '#555',
        'Неявки по невыясненным причинам': '#555',
        'Выполнение гос.обязанностей': '#834b11',
        'Межвахтовый отгул': '#b4ae81',
        'Праздники': '#e8ff00',
    };

    return (
        <>  
            <div className='personnel-data-content'>
                {loading && (<div className='loader-container'>
                    <Spin size="large"/>
                </div>)}
                <Card
                    title="СКУД (В разработке)"
                    bordered={false}
                    style={{
                        width: 300,
                        height: 150
                    }}
                    className='personnel-data-content-card'
                >
                    <a><p>Мои проходы</p></a>
                    <a><p>Проверить мои опоздания</p></a>
                </Card>
                <Card
                    title="Моя кадровая информация"
                    bordered={false}
                    style={{
                        width: 300,
                        height: 190
                    }}
                    className='personnel-data-content-card'
                >
                    <a><p>Мои кадровые документы (В разработке)</p></a>
                    <a onClick={() => setShowLeaveBalanceModal(true)}><p>Мои остатки отпусков</p></a>
                    <a onClick={() => setShowAbsenceListModal(true)}><p>Мои отсутствия</p></a>
                    <a onClick={() => setShowTimesheetModal(true)}><p>Мои табели</p></a>
                </Card>
                <Card
                    title="Мои данные по питаниям (В разработке)"
                    bordered={false}
                    style={{
                        width: 300,
                        height: 150,
                        whiteSpace: 'pre-wrap !important',
                        lineHeight: '18px'
                    }}
                    className='personnel-data-content-card'
                >
                    <a><p>Доступные виды питания</p></a>
                    <a><p>Доступные объекты питания</p></a>
                </Card>
                <div style={wrapperStyle}>
                    <Card title={'Мой график работы (В разработке)'} className='personnel-data-content-card'>
                        <Calendar fullscreen={false} onPanelChange={onPanelChange} />
                    </Card>
                </div>
            </div>
            {showLeaveBalanceModal && (
                <>
                    <div className="modal-bg" onClick={() => setShowLeaveBalanceModal(false)}></div>
                    <div className="modal" style={{ maxHeight: '80vh', padding: '16px 32px' }}>
                        <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Мои накопленные дни отпуска</h4>
                        <button
                            type="button"
                            className='btn'
                            style={{ position: "absolute", top: "8px", right: "16px" }}
                            onClick={() => setShowLeaveBalanceModal(false)}
                        >
                            <CloseOutlined />
                        </button>
                        <ul style={{ listStyle: 'none' }}>
                            {leaveBalances.map((balance, index) => (
                                <li key={index} style={{ marginBottom: '7px' }}>
                                    <p><strong>{balance.Type}</strong>: {balance.Balance} дней</p>
                                </li>
                            ))}
                        </ul>
                        <hr style={{ marginBottom: '5px' }} />
                        <p style={{ fontWeight: 'bold', fontSize: '16px' }}>Итого накоплено: {totalBalance} дней</p><br/>
                        <p style={{ display: 'block', marginTop: '16px', fontWeight: 'bold' }}>Уведомляем, что остаток отпусков указан в календарных днях, для их использования в натуральном виде.<br/><br/>В соответствии со статьей 234 ТК РУз при прекращении трудового договора, расчет компенсации за неиспользованные дни трудового отпуска, производится в рабочих днях, исходя из шестидневной рабочей недели (каждый седьмой день остатка отпусков не входит в расчет компенсации).</p>
                    </div>
                </>
            )}
            {showAbsenceListModal && (
                <>
                    <div className="modal-bg" onClick={() => setShowAbsenceListModal(false)}></div>
                    <div className="modal" style={{ maxHeight: '80vh', width: 'auto', maxWidth: '80%', padding: '16px 32px' }}>
                        <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Мои документы отсутствия</h4>
                        <button
                            type="button"
                            className='btn'
                            style={{ position: "absolute", top: "8px", right: "16px" }}
                            onClick={() => setShowAbsenceListModal(false)}
                        >
                            <CloseOutlined />
                        </button>
                        <div style={{ maxHeight: 'calc(80vh - 70px)', width: '100%', overflow: 'auto' }}>
                            <table className='applicationsTable' style={{ marginTop: '16px' }}>
                                <tbody>
                                    <tr>
                                        <th><p>Номер и дата документа</p></th>
                                        <th><p>Вид отсутствия</p></th>
                                        <th style={{ textAlign: 'center' }}><p>Количество дней</p></th>
                                        <th style={{ textAlign: 'center' }}><p>Дата начала</p></th>
                                        <th style={{ textAlign: 'center' }}><p>Дата окончания</p></th>
                                    </tr>
                                    {absenceList.map((abs, index) => (
                                        <tr key={`abs$index`}>
                                            <td><p>{abs.DocumentNumber}</p></td>
                                            <td><p><Tag color={getAbsenceColor(abs.AbsenceType)}>{abs.AbsenceType}</Tag></p></td>
                                            <td style={{ textAlign: 'center' }}><p>{abs.NumberOfDays}</p></td>
                                            <td style={{ textAlign: 'center' }}><p>{formatDate(abs.StartDate)}</p></td>
                                            <td style={{ textAlign: 'center' }}><p>{formatDate(abs.EndDate)}</p></td>
                                        </tr>                                    
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            )}
            {showTimesheetModal && (
                <>
                    <div className="modal-bg" onClick={() => setShowTimesheetModal(false)}></div>
                    <div className="modal" style={{ maxHeight: '80vh', width: 'auto', maxWidth: '90%', padding: '16px 32px' }}>
                        <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Мои табели</h4>
                        <button
                            type="button"
                            className='btn'
                            style={{ position: "absolute", top: "8px", right: "16px" }}
                            onClick={() => setShowTimesheetModal(false)}
                        >
                            <CloseOutlined />
                        </button>
                        <ConfigProvider locale={locale}>
                            <DatePicker onChange={changeTimesheetPeriod} picker="month" style={{ marginRight: '15px' }} />
                        </ConfigProvider>
                        <Button onClick={getTimesheetByPeriod}>Сформировать</Button>
                        <div style={{ width: '100%', overflow: 'auto' }}>
                            {isTimesheetDataExist === 0 && (<div></div>)}
                            {isTimesheetDataExist === 1 && (
                                <>
                                    <br />
                                    {monthName !== 'Invalid Date' && (
                                        <p>Данные табелирования за: <strong style={{ textTransform: 'capitalize' }}>{`${monthName} ${timesheetPeriod.split('-')[0]}`}</strong></p>
                                    )}
                                    <table style={{ margin: '20px 0px' }}>
                                        <tbody>
                                            <tr>
                                                <td>Дни</td>
                                                {timesheetData.map((ts, index) => (
                                                    <td key={`period-${index}`}>
                                                        <Tooltip placement="right" title={formatDate(ts.Period)} overlayStyle={{ fontSize: '12px', lineHeight: '19px' }}>
                                                            {ts.Period.split('T')[0].split('-')[2]}
                                                        </Tooltip>
                                                    </td>
                                                ))}
                                            </tr>
                                            <tr>
                                                <td>Вид времени</td>
                                                {timesheetData.map((ts, index) => (
                                                    <td key={`time-${index}`}>
                                                        <Tooltip placement="right" title={ts.TimeType} overlayStyle={{ fontSize: '12px', lineHeight: '19px' }}>
                                                            <Tag color={getTimeTypeColor(ts.TimeType)}>{ts.TimeTypeCode}</Tag>
                                                        </Tooltip>
                                                    </td>
                                                ))}
                                            </tr>
                                            <tr>
                                                <td>Часы</td>
                                                {timesheetData.map((ts, index) => (
                                                    <td key={`days-${index}`}>{ts.Hours !== 0 ? `${ts.Hours}ч` : ''}</td>
                                                ))}
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table style={{ margin: '20px 0px', width: 'auto', maxWidth: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>Вид времени</th>
                                                <th>Итого дней</th>
                                                <th>Итого часов</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.values(calculateTotals(timesheetData)).map((total, index) => (
                                                <tr key={`total-${index}`}>
                                                    <td>{total.timeTypeName}</td>
                                                    <td style={{ textAlign: 'center' }}>{total.days}</td>
                                                    <td style={{ textAlign: 'center' }}>{total.hours !== 0 && `${total.hours}ч`}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>
                            )}
                            {isTimesheetDataExist === 2 && (
                                <div style={{ padding: '16px', width: '100%' }}>
                                    <p>За выбранный период нет данных о табелировании</p>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

// Функция для подсчета итогов
const calculateTotals = (data) => {
    const totals = {};

    data.forEach((ts) => {
        if (!totals[ts.TimeTypeCode]) {
            totals[ts.TimeTypeCode] = {
                timeTypeName: ts.TimeType, // Сохранение названия вида времени
                days: 0,
                hours: 0
            };
        }
        totals[ts.TimeTypeCode].days += 1;
        totals[ts.TimeTypeCode].hours += ts.Hours;
    });

    return totals;
};

export default PersonnelDataContent;
